import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AccessPage } from "./access.page";
import { AccessLoginPage } from "./login/login.page";
import { AccessSignupPage } from "./signup/signup.page";
import { AccessForgotPasswordPage } from "./forgot-password/forgot-password.page";
import { AccessResetPasswordPage } from "./reset-password/reset-password.page";
import { AccessVerifyEmailPage } from "./verify-email/verify-email.page";

import { AGCCourierModule } from "@core";
import { AccessRoutingModule } from "./access-routing.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AGCCourierModule,
    AccessRoutingModule
  ],
  declarations: [
    AccessPage,
    AccessLoginPage,
    AccessSignupPage,
    AccessForgotPasswordPage,
    AccessResetPasswordPage,
    AccessVerifyEmailPage
  ]
})
export class AccessPageModule {}
